

// import React, { useState, useCallback } from 'react';
// import { useQuery, useMutation, gql } from '@apollo/client';
// import { debounce } from 'lodash';
// import { FaEdit, FaSave, FaTimes } from 'react-icons/fa';

// const GET_ALL_ORDERS = gql`
//   query GetAllOrders {
//     getAllOrders {
//       corporateorder_generated_id
//       customer_generated_id
//       order_details
//       total_amount
//       paymentid
//       ordered_at
//       payment_status
//       corporate_order_status
//     }
//   }
// `;

// const UPDATE_CORPORATE_ORDER_STATUS = gql`
//   mutation UpdateCorporateOrderStatus($id: ID!, $status: String!) {
//     updateCorporateOrderStatus(id: $id, status: $status) {
//       corporateorder_generated_id
//       corporate_order_status
//     }
//   }
// `;

// const CorporateOrderList = () => {
//   const [searchTerms, setSearchTerms] = useState({
//     corporateorder_generated_id: '',
//     customer_id: '',
//     order_details: '',
//     total_amount: '',
//     paymentid: '',
//     ordered_at: '',
//     payment_status: '',
//     corporate_order_status: '',
//   });
//   const [editingOrderId, setEditingOrderId] = useState(null);
//   const [editingValues, setEditingValues] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [ordersPerPage] = useState(10);
//   const [saveError, setSaveError] = useState(null);

//   const { loading, error, data } = useQuery(GET_ALL_ORDERS);
//   const [updateCorporateOrderStatus] = useMutation(UPDATE_CORPORATE_ORDER_STATUS);

//   const filteredOrders = data ? data.getAllOrders.filter(order => {
//     return Object.entries(searchTerms).every(([key, value]) => {
//       if (!value) return true;
//       return order[key]?.toString().toLowerCase().includes(value.toLowerCase());
//     });
//   }) : [];

//   const debouncedSearch = useCallback(
//     debounce((searchTerms) => {
//       setSearchTerms(searchTerms);
//       setCurrentPage(1);
//     }, 300),
//     []
//   );

//   const handleSearchChange = (e) => {
//     const { name, value } = e.target;
//     debouncedSearch({ ...searchTerms, [name]: value });
//   };

//   const handleEdit = (orderId, order) => {
//     setEditingOrderId(orderId);
//     setEditingValues({ ...order });
//     setSaveError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditingValues(prev => ({ ...prev, [name]: value }));
//     setSaveError(null);
//   };

//   const handleSave = async (orderId) => {
//     try {
//       setSaveError(null);

//       if (!editingValues.corporate_order_status) {
//         throw new Error('Order status is required');
//       }

//       await updateCorporateOrderStatus({
//         variables: {
//           id: orderId,
//           status: editingValues.corporate_order_status,
//         },
//         update: (cache) => {
//           const existingOrders = cache.readQuery({ query: GET_ALL_ORDERS });
//           const updatedOrders = existingOrders.getAllOrders.map(order => 
//             order.corporateorder_generated_id === orderId
//               ? { ...order, corporate_order_status: editingValues.corporate_order_status }
//               : order
//           );
//           cache.writeQuery({
//             query: GET_ALL_ORDERS,
//             data: { getAllOrders: updatedOrders },
//           });
//         },
//       });

//       setEditingOrderId(null);
//     } catch (error) {
//       console.error('Error updating order:', error);
//       setSaveError(error.message);
//     }
//   };

//   const handleDiscard = () => {
//     setEditingOrderId(null);
//     setSaveError(null);
//   };

//   const headers = [
//     { key: 'corporateorder_generated_id', label: 'Order ID' },
//     { key: 'customer_generated_id', label: 'Cust. ID' },
//     { key: 'order_details', label: 'Details' },
//     { key: 'total_amount', label: 'Amount' },
//     { key: 'ordered_at', label: 'Date' },
//     { key: 'paymentid', label: 'Pay. ID' },
//     { key: 'payment_status', label: 'Pay. Status' },
//     { key: 'corporate_order_status', label: 'Order Status' },
//     { key: 'actions', label: 'Actions' }
//   ];

//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <div className="text-2xl font-semibold text-gray-600">Loading...</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <div className="text-2xl font-semibold text-red-600">Error: {error.message}</div>
//       </div>
//     );
//   }

//   return (
//     <div className="container mx-auto p-4">
//       <h1 className="text-3xl font-bold text-gray-900 mb-6">Corporate Order List</h1>
//       {saveError && (
//         <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
//           <p>{saveError}</p>
//         </div>
//       )}
//       <div className="overflow-x-auto">
//         <table className="min-w-full bg-white">
//           <thead className="bg-gray-50">
//             <tr>
//               {headers.map(header => (
//                 <th key={header.key} className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   {header.label}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             <tr className="bg-white">
//               {headers.map(header => (
//                 <td key={header.key} className="px-4 py-2">
//                   {header.key !== 'actions' && (
//                     <input
//                       type="text"
//                       name={header.key}
//                       placeholder={`Search ${header.label}`}
//                       value={searchTerms[header.key]}
//                       onChange={handleSearchChange}
//                       className="w-full p-1 border rounded text-xs focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   )}
//                 </td>
//               ))}
//             </tr>
//             {currentOrders.map((order) => (
//               <tr key={order.corporateorder_generated_id} className="hover:bg-gray-50">
//                 {headers.map(header => (
//                   <td key={header.key} className="px-4 py-2 text-sm">
//                     {editingOrderId === order.corporateorder_generated_id && header.key === 'corporate_order_status' ? (
//                       <input
//                         type="text"
//                         name="corporate_order_status"
//                         value={editingValues.corporate_order_status || ''}
//                         onChange={handleInputChange}
//                         className="w-full p-1 border rounded text-xs focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       />
//                     ) : header.key === 'actions' ? (
//                       <div className="flex justify-center space-x-1">
//                         {editingOrderId === order.corporateorder_generated_id ? (
//                           <>
//                             <button onClick={() => handleSave(order.corporateorder_generated_id)} className="text-green-600 hover:text-green-900">
//                               <FaSave className="w-4 h-4" />
//                             </button>
//                             <button onClick={handleDiscard} className="text-gray-600 hover:text-gray-900">
//                               <FaTimes className="w-4 h-4" />
//                             </button>
//                           </>
//                         ) : (
//                           <button onClick={() => handleEdit(order.corporateorder_generated_id, order)} className="text-blue-600 hover:text-blue-900">
//                             <FaEdit className="w-4 h-4" />
//                           </button>
//                         )}
//                       </div>
//                     ) : (
//                       <div className="whitespace-pre-wrap">{JSON.stringify(order[header.key], null, 2)}</div>
//                     )}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="mt-4 flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
//         <div className="flex sm:flex-1 sm:items-center sm:justify-between">
//           <div>
//             <p className="text-sm text-gray-700">
//               Showing <span className="font-medium">{indexOfFirstOrder + 1}</span> to{' '}
//               <span className="font-medium">{Math.min(indexOfLastOrder, filteredOrders.length)}</span> of{' '}
//               <span className="font-medium">{filteredOrders.length}</span> results
//             </p>
//           </div>
//           <div>
//             <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
//               {[...Array(Math.ceil(filteredOrders.length / ordersPerPage))].map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => paginate(index + 1)}
//                   className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
//                     currentPage === index + 1
//                       ? 'z-10 bg-indigo-600 text-white'
//                       : 'text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50'
//                   }`}
//                 >
//                   {index + 1}
//                 </button>
//               ))}
//             </nav>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CorporateOrderList;





import React, { useState, useCallback } from 'react';
import { useQuery, useMutation, gql } from '@apollo/client';
import { debounce } from 'lodash';
import { FaEdit, FaSave, FaTimes } from 'react-icons/fa';

const GET_ALL_ORDERS = gql`
  query GetAllOrders {
    getAllOrders {
      corporateorder_generated_id
      customer_generated_id
      order_details
      total_amount
      paymentid
      ordered_at
      payment_status
      corporate_order_status
    }
  }
`;

const UPDATE_CORPORATE_ORDER_STATUS = gql`
  mutation UpdateCorporateOrderStatus($id: ID!, $status: String!) {
    updateCorporateOrderStatus(id: $id, status: $status) {
      corporateorder_generated_id
      corporate_order_status
    }
  }
`;

const CorporateOrderList = () => {
  const [searchTerms, setSearchTerms] = useState({
    corporateorder_generated_id: '',
    customer_generated_id: '',
    order_details: '',
    total_amount: '',
    paymentid: '',
    ordered_at: '',
    payment_status: '',
    corporate_order_status: '',
  });
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [editingValues, setEditingValues] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(10);
  const [saveError, setSaveError] = useState(null);

  const { loading, error, data } = useQuery(GET_ALL_ORDERS);
  const [updateCorporateOrderStatus] = useMutation(UPDATE_CORPORATE_ORDER_STATUS);

  const filteredOrders = data ? data.getAllOrders.filter(order => {
    return Object.entries(searchTerms).every(([key, value]) => {
      if (!value) return true;
      return order[key]?.toString().toLowerCase().includes(value.toLowerCase());
    });
  }) : [];

  const debouncedSearch = useCallback(
    debounce((searchTerms) => {
      setSearchTerms(searchTerms);
      setCurrentPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    debouncedSearch({ ...searchTerms, [name]: value });
  };

  const handleEdit = (orderId, order) => {
    setEditingOrderId(orderId);
    setEditingValues({ ...order });
    setSaveError(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditingValues(prev => ({ ...prev, [name]: value }));
    setSaveError(null);
  };

  const handleSave = async (orderId) => {
    try {
      setSaveError(null);

      if (!editingValues.corporate_order_status) {
        throw new Error('Order status is required');
      }

      await updateCorporateOrderStatus({
        variables: {
          id: orderId,
          status: editingValues.corporate_order_status,
        },
        update: (cache) => {
          const existingOrders = cache.readQuery({ query: GET_ALL_ORDERS });
          const updatedOrders = existingOrders.getAllOrders.map(order => 
            order.corporateorder_generated_id === orderId
              ? { ...order, corporate_order_status: editingValues.corporate_order_status }
              : order
          );
          cache.writeQuery({
            query: GET_ALL_ORDERS,
            data: { getAllOrders: updatedOrders },
          });
        },
      });

      setEditingOrderId(null);
    } catch (error) {
      console.error('Error updating order:', error);
      setSaveError(error.message);
    }
  };

  const handleDiscard = () => {
    setEditingOrderId(null);
    setSaveError(null);
  };

  const headers = [
    { key: 'corporateorder_generated_id', label: 'Order ID' },
    { key: 'customer_generated_id', label: 'Cust. ID' },
    { key: 'order_details', label: 'Details' },
    { key: 'total_amount', label: 'Amount' },
    { key: 'ordered_at', label: 'Date' },
    { key: 'paymentid', label: 'Pay. ID' },
    { key: 'payment_status', label: 'Pay. Status' },
    { key: 'corporate_order_status', label: 'Order Status' },
    { key: 'actions', label: 'Actions' }
  ];

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-2xl font-semibold text-gray-600">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-2xl font-semibold text-red-600">Error: {error.message}</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Corporate Order List</h1>
      {saveError && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
          <p>{saveError}</p>
        </div>
      )}
      <div className="overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left text-gray-900">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              {headers.map(header => (
                <th key={header.key} className="px-6 py-3">
                  {header.label !== 'Actions' ? header.label : ''}
                </th>
              ))}
            </tr>
            <tr>
              {headers.map(header => (
                <th key={header.key} className="px-6 py-3">
                  {header.key !== 'actions' && (
                    <input
                      type="text"
                      name={header.key}
                      className="w-full px-2 py-1 text-sm border rounded"
                      placeholder={`Search ${header.label}`}
                      value={searchTerms[header.key]}
                      onChange={handleSearchChange}
                    />
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentOrders.map((order) => (
              <tr key={order.corporateorder_generated_id} className="bg-white border-b">
                {headers.map(header => (
                  <td key={header.key} className="px-6 py-4 whitespace-nowrap">
                    {editingOrderId === order.corporateorder_generated_id && header.key === 'corporate_order_status' ? (
                      <input
                        type="text"
                        name="corporate_order_status"
                        value={editingValues.corporate_order_status || ''}
                        onChange={handleInputChange}
                        className="w-full px-2 py-1 text-sm border rounded"
                      />
                    ) : header.key === 'actions' ? (
                      <div className="flex justify-center space-x-1">
                        {editingOrderId === order.corporateorder_generated_id ? (
                          <>
                            <button onClick={() => handleSave(order.corporateorder_generated_id)} className="text-green-600 hover:text-green-900">
                              <FaSave />
                            </button>
                            <button onClick={handleDiscard} className="text-gray-600 hover:text-gray-900">
                              <FaTimes />
                            </button>
                          </>
                        ) : (
                          <button onClick={() => handleEdit(order.corporateorder_generated_id, order)} className="text-blue-600 hover:text-blue-900">
                            <FaEdit />
                          </button>
                        )}
                      </div>
                    ) : (
                      <div className="whitespace-pre-wrap">{JSON.stringify(order[header.key], null, 2)}</div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        
        <div className="mt-4 flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
          <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
            
            <div>
              <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                {[...Array(Math.ceil(filteredOrders.length / ordersPerPage))].map((_, index) => (
                  <button
                    key={index}
                    onClick={() => paginate(index + 1)}
                    className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                      currentPage === index + 1
                        ? 'z-10 bg-indigo-600 text-white'
                        : 'text-gray-900 ring-1 ring-inset ring-gray-300'
                    }`}
                  >
                    {index + 1}
                  </button>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorporateOrderList;
